/* Zarafae motion: scroll reveals. No dependencies. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const enabled = document.body.classList.contains('zf-motion-ok');
  if (!enabled || reduced) return;
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('zf-in');
          io.unobserve(e.target);
        }
      }
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
  );
  const init = (root) => {
    root.querySelectorAll('.zf-reveal').forEach((el) => io.observe(el));
  };
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
